/* eslint-disable */
import React, { useCallback, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useMount, useUpdateEffect, usePrevious } from 'react-use'
import { Link } from 'react-router-dom'
import dayjs from 'dayjs'
import qs from 'qs'
import { Button, Avatar, Table, Tag, Breadcrumb } from 'antd'
import { withQuery } from '@/utils'
import * as actions from '@/models/members/actions'
import * as selectors from '@/models/members/selectors'
import styles from './members.module.scss'

const tagMapping = {
  manager: {
    color: '#f50',
    name: '管理员'
  },
  staff: {
    color: '#87d068',
    name: '企业员工'
  },
  worker: {
    color: '#108ee9',
    name: '师傅'
  }
}

function getColumns() {
  const dispatch = useDispatch()

  return [
    {
      key: '_id',
      title: '',
      width: 30,
      render: (text, record, idx) => <div style={{ whiteSpace: 'nowrap' }}>{idx + 1}.</div>
    },
    {
      title: '微信头像',
      dataIndex: 'avatar',
      render: avatar => (
        <Avatar shape="square" size={42} src={avatar} />
      )
    },
    {
      title: '姓名',
      render: item => (
        <div>
          <div>{item.name}</div>
          <h3>{item.mobile}</h3>
        </div>
      )
    },
    {
      title: '地域',
      render: item => (
        <div>
          <div>{item.wechat && item.wechat.province}</div>
          <div>{item.wechat && item.wechat.city}</div>
        </div>
      )
    },
    {
      title: '角色',
      render: item => {
        if (!item.roles) {
          return <Tag color="#2db7f5">普通用户</Tag>
        }

        return Object.entries(item.roles).map(([key]) => {
          return tagMapping[key] && (
            <Tag key={key} color={tagMapping[key].color}>{tagMapping[key].name}</Tag>
          )
        })
      }

    },
    {
      title: '近期登录时间',
      render: item => (
        <div>
          {item.lastLoginAt ? dayjs(item.lastLoginAt).fromNow() : '-'}
        </div>
      )
    },
    {
      title: '状态',
      render: item => (
        <div style={{ color: item.isActive ? '#87d068' : '#CCC' }}>
          {item.isActive ? '正常' : '禁用'}
        </div>
      )
    },
    {
      title: '操作',
      render: item => {
        const setActiveAction = () =>
          dispatch(actions.setActiveState(item._id, !item.isActive))

        return (
          <div>
            <a
              onClick={setActiveAction}>
              {item.isActive ? '设为禁用' : '解除禁用'}
            </a>
          </div>
        )
      }
    }
  ]
}

function MemberList(props) {
  const dispatch = useDispatch()
  const { query, history, match, location } = props
  const prevQuery = usePrevious(query)
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [queryParams, setQueryParams] = useState({});
  const loading = useSelector(selectors.loadingSelector)
  const total = useSelector(selectors.totalSelector)
  const members = useSelector(selectors.entriesSelectors)
  const pagination = {
    showTotal: total => `共计 ${total}个 用户`,
    showQuickJumper: true,
    total: total,
    pageSize: +limit,
    current: Math.floor(offset / +limit) + 1
  }

  const fetch = useCallback((params = {}) => {
    params = { ...queryParams, ...params }
    params.offset = params.offset || offset
    params.limit = params.limit || limit
    setLimit(params.limit)
    setOffset(params.offset)
    setQueryParams(params)

    dispatch(actions.fetchList(params))
  }, [queryParams])

  const handleTableChange = useCallback((pagination, filters, sorter) => {
    const nextQuery = {
      ...query,
      ...filters,
      offset: (pagination.current - 1) * pagination.pageSize
    }

    if (sorter && sorter.field) {
      nextQuery.sort = (sorter.order && sorter.order === 'descend' ? '' : '-') + sorter.field
    }
    window.scrollTop = 0
    fetch(nextQuery)
  })

  const columns = getColumns()

  useMount(() => {
    fetch(query)
  })

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Breadcrumb>
          <Breadcrumb.Item>用户管理</Breadcrumb.Item>
          <Breadcrumb.Item>列表</Breadcrumb.Item>
        </Breadcrumb>
      </div>
      <Table
        className={styles.table}
        columns={columns}
        rowKey="_id"
        dataSource={members.toJS()}
        pagination={pagination}
        onChange={handleTableChange}
        loading={loading}></Table>
    </div>
  )
}

export default withQuery(MemberList)
